module.exports = __webpack_public_path__ + "static/img/paigu.34028b07.png";